import { logError } from '~/helpers/logError';
import { StorefrontEngager } from '~/hooks/useEngagerData';
import { PropertyExplorerProjectData } from '~/queries/getPropertyExplorerProjectData';

type Placement = 'portal' | 'm360' | 'web';
type Environment = 'preview' | 'live';

const searchParams = new URLSearchParams(window.location.search);

const placement = (searchParams.get('placement') || 'web') as Placement;
const environment = (searchParams.get('environment') || 'live') as Environment;

export const checkPropertyExplorerPublishStatus = (data: PropertyExplorerProjectData): boolean => {
  if (environment === 'preview') return true;

  if (['web', 'm360'].includes(placement)) {
    if (data.apiPublished && data.project.apiPublished) {
      return true;
    } else {
      logError(`Please check if the project and its property picker have been published to API.`);

      return false;
    }
  }

  if (placement === 'portal') {
    if (data.portalPublished && data.project.portalPublished) {
      return true;
    } else {
      logError(
        `Please check if the project and its property picker have been published to Newbuilds.com.`,
      );

      return false;
    }
  }

  logError(`Unknown placement, please check your embed code.`);

  return false;
};

export const checkEngagerPublishStatus = (data: StorefrontEngager): boolean => {
  if (environment === 'preview') return true;

  if (['web', 'm360'].includes(placement)) {
    if (data.api_published && data.project.api_published) {
      return true;
    } else {
      logError(`Please check if the project and its engager have been published to API.`);

      return false;
    }
  }

  if (placement === 'portal') {
    if (data.portal_published && data.project.portal_published) {
      return true;
    } else {
      logError(`Please check if the project and its engager have been published to Newbuilds.com.`);

      return false;
    }
  }

  logError(`Unknown placement, please check your embed code.`);

  return false;
};
